<template>
  <core-main-table
    :headers="orderItemsTableHeaders"
    :items="items"
    class="my-4 ml-4"
    rights-group="rfq"
    hide-default-footer
  >
    <template v-slot:item.partPricing="{ item }">
      <core-table-unit-pricing :item="item.part" />
    </template>

    <template v-slot:item.partThickness="{ item }">
      <span>
        {{ item.part.thickness }} {{ item.part.thickness ? 'mm' : '' }}
      </span>
    </template>

    <template v-slot:item.totalPrice="{ item }">
      <span>
        {{
          formatCurrency(getItemPrice(
            {...item.part, ...{ quantity: item.quantity } })
            * item.quantity)
        }}
      </span>
    </template>
  </core-main-table>
</template>

<script>
import CurrencyFormatterMixin from '../../../mixins/currencyFormatter';

export default {
  name: 'OrderItemsTable',

  mixins: [
    CurrencyFormatterMixin,
  ],

  props: {
    items: Array,
  },

  computed: {
    orderItemsTableHeaders() {
      return [
        {
          text: 'Client part #',
          value: 'part.clientPartNo',
        },
        {
          text: 'Komacut Part #',
          value: 'part.manufacturerPartNo',
        },
        {
          text: 'Description',
          value: 'part.description',
        },
        {
          text: 'Material',
          value: 'part.material',
        },
        {
          text: 'Finish',
          value: 'part.finish',
        },
        {
          text: 'Thickness',
          value: 'part.thickness',
        },
        {
          text: 'Unit price',
          value: 'part.pricing',
        },
        {
          text: 'Qty',
          value: 'quantity',
        },
        {
          text: 'Total price',
          value: 'totalPrice',
        }
      ];
    },
  },

  methods: {
    getItemPrice(item) {
      const sortedByPrice = _.sortBy(item.pricing, p => p.minQuantity);
      const itemPrice = _.find(sortedByPrice, p => p.minQuantity >= item.quantity);
      if (itemPrice) {
        return itemPrice.price;
      }
      return item.quantity ? _.last(sortedByPrice).price : 0;
    },
  },
};
</script>

<style scoped>

</style>
